import { ActionReducerMap } from '@ngrx/store';
import { jfLibReducers } from '@adnova/jf-ng-components';
import { AppState } from './app.state';

/**
 * Root-Reducers der Anwendung.
 * Enthält jf-lib Reducers und wird erweitert, wenn weitere Features NgRx nutzen.
 */
export const appReducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
};
